import { icons } from 'common'
import { MSG_TYPE } from 'constants/index'

export const parseUserMessage = (rawMessage: TRawUserMessage, isFirstLoad: boolean = false): TParsedMessage => {
  let message
  try {
    message = JSON.parse(rawMessage.message)
  } catch (err) {
    message = {
      text: rawMessage.message,
      media: [],
    }
  }
  const avatar = rawMessage.logoUrl || rawMessage.avatar || icons.default_avatar_square
  const parsedMessage = {
    isFirstLoad,
    ...rawMessage,
    message,
    // messageType: MSG_TYPE.USER,
    avatar,
  }

  return parsedMessage
}
